import "./SharedLayout.css";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaSignOutAlt, FaBars } from "react-icons/fa";
import { api } from "./env";
import { useAuth } from "./AuthContext";
import React, { useState, Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
const Loader = lazy(() => import("./compenents/loader/loader"));
const NavBar = lazy(() => import("./compenents/navBar/navBar"));

const SharedLayout = () => {
  const { user, showSlider, setIsAuthentified, setShowSilder } = useAuth();
  const { i18n } = useTranslation();
  const language = i18n.language;
  const [showLoader, setShowLoader] = useState(false);
  const isRTL = i18n.language === "ar";

  const navigate = useNavigate();
  
  const logout = async () => {
    setShowLoader(true);
    try {
      await api("/api/logout");
      setIsAuthentified(false);
      navigate("/Login");
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <Suspense fallback={<Loader show={showLoader} />}>
      <div className={`shared-layout-container ${isRTL ? "rtl" : "ltr"}`}>
        {/* Modern Top Navigation Bar */}
        {user && (
          <nav className="modern-topnav">
            <div className="topnav-content">
              {/* Left Section */}
              <div className="topnav-left">
                <button
                  className="menu-toggle-btn"
                  onClick={() => setShowSilder(!showSlider)}
                  title={language === "ar" ? "فتح القائمة" : "Ouvrir le menu"}
                >
                  <FaBars />
                </button>
                <span className="topnav-brand">
                  {language === "ar" ? "فضاء OPGI" : "Espace OPGI"}
                </span>
              </div>

              {/* Right Section */}
              <div className="topnav-right">

                {/* User Profile Section */}
                {user && (
                  <div className="user-profile-section">
                    <div className="user-avatar-small">
                      {user.name?.charAt(0).toUpperCase() || "U"}
                    </div>
                    <div className="user-info-small">
                      <span className="user-name-small">{user.name}</span>
                      <span className="user-role-small">
                        {language === "ar" ? "مسؤول" : "Admin"}
                      </span>
                    </div>
                    <button
                      className="logout-btn-small"
                      onClick={logout}
                      disabled={showLoader}
                      title={language === "ar" ? "تسجيل خروج" : "Déconnexion"}
                    >
                      <FaSignOutAlt />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </nav>
        )}

        {/* Sidebar Navigation */}
        {user && <NavBar />}

        {/* Main Content Section */}
        <main className="dashboard-section">
          <Suspense fallback={<Loader show={true} />}>
            <Outlet />
          </Suspense>
        </main>

        {/* Loader */}
        <Loader show={showLoader} />
      </div>
    </Suspense>
  );
};

export default SharedLayout;